import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import {
  Container, Modal, Accordion, Button
} from 'react-bootstrap';

import _ from 'lodash';
import cx from 'classnames';

import { updateWidgetProperty } from 'actions/editor';
import { FontBackgroundSettings, ResponseDesignSettings, SeekLayoutSettings } from '../properties';
import { DesignPreview } from './designPreview';

import styles from './responsiveDesign.module.scss'

const ResponsiveDesign = ({ show, id, className, editorSession, widgetProps, onClose }) => {
  const dispatch = useDispatch();
  const [seekDesign, setSeekDesign] = useState("fontBackground");

  const breakpoint = useSelector((state) =>
    _.get(state, `${editorSession}.present.breakpoint`)
  );

  const [deviceLayout, setDeviceLayout] = useState(breakpoint);
  const [widgetData, setWidgetData] = useState({});

  const handleDeviceLayout = (type) => {
    setDeviceLayout(type)
  }

  const handlePropertyChange = (type, value) => {
    const deviceProperties = _.get(widgetData, `properties.${deviceLayout}`);
    const properties = _.get(widgetData, `properties`);

    setWidgetData({
      ...widgetData,
      properties: {
        ...properties,
          [deviceLayout]: { 
            ...deviceProperties,
            [type]: value
          }
      }
    })
  }

  useEffect(()=>{
    if(widgetProps){
      handleResetProperties();
    }
  },[])

  const handleSaveChanges = () => {
    dispatch(updateWidgetProperty(editorSession, id, deviceLayout, _.get(widgetData, `properties.${deviceLayout}`)));
    onClose();
  }

  const handleResetProperties = () => {
    setWidgetData(widgetProps)
  }

  return (
    <Modal 
      show={show} 
      className={styles.seekDesignModal} 
      backdropClassName={styles.backdrop} 
      centered 
      restoreFocus={false}
      enforceFocus={false}
    >
      <Header deviceLayout={deviceLayout} breakpoint={breakpoint} handleDeviceLayout={handleDeviceLayout} onClose={onClose}/>
      <Modal.Body className={styles.modalBody}>
        <Container fluid className={styles.seekDesignContainer}>
            {deviceLayout == "mobile" && 
              <div className={`${styles.devicesSwitcher} ${styles.mobileSwitcher}`}>
                  <Button variant="info" className={cx(styles.deviceButton, {[styles.active]:deviceLayout == 'desktop'})} onClick={()=>handleDeviceLayout('desktop')}>
                    <i className={cx("cleverstory-laptop", styles.icon)} />
                  </Button>
                  <Button variant="info" className={cx(styles.deviceButton, {[styles.active]: deviceLayout == 'mobile'})} onClick={()=>handleDeviceLayout('mobile')}>
                    <i className={cx("cleverstory-mobile", styles.icon)} />
                  </Button>
              </div>
            }
            <EditMenu 
              id={id}
              widgetProps={widgetData}
              deviceLayout={deviceLayout}
              setSeekDesign={setSeekDesign}
              handleResetProperties={handleResetProperties}
              handlePropertyChange={handlePropertyChange}
              handleSaveChanges={handleSaveChanges}
            />
            <DesignPreview 
              handleDeviceLayout={handleDeviceLayout}
              deviceLayout={deviceLayout}
              widgetProps={widgetData}
              seekDesign = "responseDesign"
              handleSaveChanges={handleSaveChanges}
              handleResetProperties={handleResetProperties}
            />
            {deviceLayout == "mobile" && 
              <footer className={styles.mobileActionsContainer}>
                <Button onClick={handleSaveChanges} variant="primary">Save & Close</Button>
                <Button onClick={handleResetProperties} variant="secondary">Reset</Button>
              </footer>
            }
        </Container>
      </Modal.Body>
    </Modal>
  )
}

const EditMenu = React.memo(({id, widgetProps, deviceLayout, handlePropertyChange, handleSaveChanges, handleResetProperties, setSeekDesign}) =>  {

  return (
    <div className={styles.editMenuPanel}>
      <ResponseDesignSettings
        id={id}
        widget={widgetProps}
        breakpoint={deviceLayout}
        handlePropertyChange={handlePropertyChange}
      />
    </div>
  )
})

const Header = ({ onClose, handleDeviceLayout, deviceLayout, breakpoint }) => {    
  return (
    <Modal.Header className={styles.header}>
      <div className={styles.modalDetails}>
        <div className={styles.title}>
          Seek Design
        </div>
      </div>
      <div className={styles.actions}>
        <Button variant='info' onClick={onClose} className={cx(styles.closeButton)}>
          <i className={cx("cleverstory-close", styles.icon)} />
        </Button>
      </div>
    </Modal.Header>
  )
}

export default ResponsiveDesign